module.exports = __webpack_public_path__ + "img/loading.34c1222c.gif";